export var buildEnv = {
    datacenter: 'us',
    env: 'production',
    version: '1.8.1',
};
//# sourceMappingURL=buildEnv.js.map